import script from "./Nopower.vue?vue&type=script&setup=true&lang=js"
export * from "./Nopower.vue?vue&type=script&setup=true&lang=js"

import "./Nopower.vue?vue&type=style&index=0&id=3b88d8f8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b88d8f8"]])

export default __exports__